// backend handlers
import LoginHandler from './LoginHandler'

function HandlersFactory(dashboardInstance) {
    return [
        new LoginHandler(dashboardInstance)
    ]
}

export default HandlersFactory